// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/PlatformWebhooks_TestSendInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * POST /platform-webhooks/test-send — emit `event` (from the catalog) as a TEST
 * event (test:true, sample payload unless `data` overrides it) to ONE
 * subscription and deliver it right now, synchronously, returning the outcome.
 */
import { registerContract } from './validate'

export interface PlatformWebhooks_TestSendInput {
subscription_id: number
event?: string
data?: Record<string, unknown>
}

registerContract('PlatformWebhooks_TestSendInput', {
  subscription_id: { type: 'number',  required: true },
  event:           { type: 'string',  required: false },
  data:            { type: 'object',  required: false },
})
